import PublicLinkHandlerContainer from './public_link_handler_container';

const PublicLinkHandler = PublicLinkHandlerContainer;
export default PublicLinkHandler;
